/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type LabReportDetectionMethodDtoMethod =
  (typeof LabReportDetectionMethodDtoMethod)[keyof typeof LabReportDetectionMethodDtoMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LabReportDetectionMethodDtoMethod = {
  MICROSCOPIC_DIRECT_DETECTION: 'MICROSCOPIC_DIRECT_DETECTION',
  MOLECULAR_BIOLOGICAL_DIRECT_DETECTION: 'MOLECULAR_BIOLOGICAL_DIRECT_DETECTION',
  CULTURE: 'CULTURE',
} as const;
